import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {Button, Form, FormGroup, Input, Label} from "reactstrap";

const Activate = () => {
    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState(null);
    const location = useLocation();
    const [token, setToken] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [passwordHint, setPasswordHint] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get("token");
        console.log(token)
        if (token) setToken(token);

        fetch(`http://localhost:8080/activate/prepare/big?token=${token}`)
            .then(res => res.json())
            .then(data => {
                setResult(data);
                setFirstName(data.firstName || "");
                setLastName(data.lastName || "");
                setEmail(data.email || "");
                setLoading(false);
            })
            .catch((error) => {
                console.log("error", error);
                setResult({ error: error });
                setLoading(false);
            });

    }, [location.search]);

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Token:", token, "Phone:", phone, "First Name:", firstName, "Last Name:", lastName, "Email:", email);
    };

    const validatePassword = (pwd) => {
        if (!pwd) return "Password is required.";
        if (pwd.length < 8) return "At least 8 characters.";
        if (!/[A-Z]/.test(pwd)) return "Include an uppercase letter.";
        if (!/[a-z]/.test(pwd)) return "Include a lowercase letter.";
        if (!/[0-9]/.test(pwd)) return "Include a number.";
        if (!/[^A-Za-z0-9]/.test(pwd)) return "Include a special character.";
        return "Strong password.";
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        setPasswordHint(validatePassword(value));
    };

    if (loading) return <div>Activating...</div>;
    // if (result?.error) return <div>{result.error}</div>;
    if (result?.error) {
        return <div dangerouslySetInnerHTML={{ __html: result.error }} />;
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Input
                type="hidden"
                name="token"
                id="token"
                value={token}
                readOnly
            />
            <FormGroup>
                <Label for="email">Email</Label>
                <Input
                    type="email"
                    name="email"
                    id="email"
                    value={email}
                    disabled
                />
            </FormGroup>
            <FormGroup>
                <Label for="firstName">First Name</Label>
                <Input
                    type="text"
                    name="firstName"
                    id="firstName"
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    required
                />
            </FormGroup>
            <FormGroup>
                <Label for="lastName">Last Name</Label>
                <Input
                    type="text"
                    name="lastName"
                    id="lastName"
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                    required
                />
            </FormGroup>
            <FormGroup>
                <Label for="phone">Phone Number</Label>
                <Input
                    type="tel"
                    name="phone"
                    id="phone"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                    required
                />
            </FormGroup>
            <FormGroup>
                <Label for="password">Password</Label>
                <Input
                    type="password"
                    name="password"
                    id="password"
                    value={password}
                    onChange={handlePasswordChange}
                    required
                />
                <small style={{ color: passwordHint === "Strong password." ? "green" : "red" }}>
                    {passwordHint}
                </small>
            </FormGroup>
            <Button type="submit" color="primary">Activate</Button>
        </Form>
    );
};

export default Activate;